<!--
 * @Description: 站点地图
 * @Author: F-Stone
 * @LastEditTime: 2023-10-31 18:12:29
-->

<template>
  <div :class="$style['m-site-map']">
    <div class="m-container">
      <div :class="$style['container-inner']">
        <div :class="$style['social-contact']" class="grid">
          <div :class="$style['state--pos-left']">
            <div :class="$style['nav-logo']" class="flex items-center">
              <img
                :class="$style['logo-img']"
                src="../../assets/images/newLogoV3.png"
                alt="superex"
              />
            </div>
          </div>
          <div :class="$style['state--pos-right']">
            <div
              :class="$style['social-group']"
              class="grid grid-flow-col-dense"
            >
              <div
                v-for="(item, index) in socialContactList"
                :key="index"
                :class="$style['social-item']"
              >
                <a
                  v-if="item.link"
                  :class="$style['item-inner']"
                  class="flex justify-center items-center"
                  :href="item.link"
                  target="_blank"
                >
                  <UeIcon :name="item.icon" />
                </a>
                <button
                  v-if="item.sub"
                  :class="$style['item-inner']"
                  class="flex justify-center items-center"
                  @click="showSubGroup = item.type"
                >
                  <UeIcon :name="item.icon" />
                </button>
                <Drawer
                  v-if="item.sub"
                  :visible="showSubGroup === item.type"
                  @close="showSubGroup = ''"
                >
                  <template #default="{ close }">
                    <div :class="$style['group--sub']">
                      <div :class="$style['group--sub-title']">
                        <span class="text">
                          {{ item.title }}
                        </span>
                        <button
                          :class="$style['btn--close']"
                          class="flex justify-center items-center"
                          @click="close()"
                        >
                          <UeIcon :class="$style['ic']" name="x-close" />
                        </button>
                      </div>
                      <div
                        :class="$style['group--sub-inner']"
                        class="grid grid-cols-1"
                      >
                        <a
                          v-for="(subItem, subIndex) in item.sub"
                          :key="subIndex"
                          :href="subItem.link"
                          :class="$style['sub-item']"
                        >
                          <span :class="$style['text']">{{
                            subItem.title
                          }}</span>
                        </a>
                      </div>
                    </div>
                  </template>
                </Drawer>
              </div>
            </div>
          </div>
        </div>
        <div :class="$style['site-map']">
          <div
            v-for="(item, index) in siteMapList"
            :key="index"
            :class="$style['col-group']"
          >
            <div
              :class="$style['group-title']"
              class="flex justify-between items-center"
              @click="openGroup"
            >
              <span class="text" style="color:#fff">{{ $t(item.title) }}</span>
              <UeIcon :class="$style['ic']" name="arrow-down" />
            </div>
            <div :class="$style['group-body']">
              <div :class="$style['sub-group']" class="grid">
                <!-- <a
                  v-for="(subItem, subIndex) in item.sub"
                  :key="subIndex"
                  :href="subItem.link"
                  :class="$style['sub-item']"
                > -->
                <a
                  v-for="(subItem, subIndex) in item.sub"
                  :key="subIndex"
                  :href="subItem.link"
                  :class="$style['sub-item']"
                  @click="handleSubItemClick(subItem.title)"
                >
                  <span :class="$style['text']">{{ $t(subItem.title) }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Drawer from "@/components/Drawer.vue";
import Drawer from "./Drawer.vue";
import { socialContactList, siteMapList } from "../../data/site-map";

import {mapGetters} from 'vuex'

const publicPath = process.env.PUBLIC_PATH;

export default {
  components: {
    Drawer
  },
  data() {
    return {
      showSubGroup: null,
      socialContactList,
      siteMapList
    };
  },
  computed: {
    ...mapGetters(['language'])
  },
  methods: {
    handleSubItemClick(title){
        if (title === "300263") {
            console.log('点击了服务协议');
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk/articles/4413122414105');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko/articles/4413122441497')
            }else{
                window.open('https://support.superex.com/hc/en-001/articles/4413122427545')
            }
        }
        else if(title === "300264"){
            console.log('点击了隐私条款');
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk/articles/11461213305625');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko/articles/11478725012761')
            }else{
                window.open('https://support.superex.com/hc/en-001/articles/11478863478809')
            }
        }else if(title === "300265"){
            //公告中心
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk/categories/4410470420249');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko/categories/4410470420249')
            }else{
                window.open('https://support.superex.com/hc/en-001/categories/4410470420249')
            }
        }else if(title === "300267"){
            //新手中心
            console.log('新手中心');
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk/categories/4412787796889-%E6%96%B0%E6%89%8B%E4%B8%AD%E5%BF%83');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko/categories/4412787796889-%EC%B4%88%EB%B3%B4%EC%9E%90-%EC%95%84%EC%B9%B4%EB%8D%B0%EB%AF%B8')
            }else{
                window.open('https://support.superex.com/hc/en-001/categories/4412787796889-Beginner-s-Center')
            }
        }else if(title === "300268"){
            //现货交易
            console.log('现货交易');
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk/categories/4410478890137-%E7%8F%BE%E8%B2%A8-%E6%9D%A0%E6%9D%86%E4%BA%A4%E6%98%93');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko/categories/4410478890137-%ED%98%84%EB%AC%BC-%EB%A0%88%EB%B2%84%EB%A6%AC%EC%A7%80-%EA%B1%B0%EB%9E%98')
            }else{
                window.open('https://support.superex.com/hc/en-001/categories/4410478890137-Spot-Leveraged-Trading')
            }
        }else if(title === '300269'){
            //合约交易
            console.log('合约交易');
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk/categories/4410478992793-%E5%90%88%E7%B4%84%E4%BA%A4%E6%98%93');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko/categories/4410478992793-%EC%84%A0%EB%AC%BC-%EA%B1%B0%EB%9E%98')
            }else{
                window.open('https://support.superex.com/hc/en-001/categories/4410478992793-Futures-Trading')
            }
        }else if(title === 'FAQ'){
            console.log('点击了FAQ');
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk/categories/4412774906905-%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko/categories/4412774906905-FAQ')
            }else{
                window.open('https://support.superex.com/hc/en-001/categories/4412774906905-FAQ')
            }
        }else if(title === "300277"){
            if(this.language == 'zh-TC'){
                window.open('https://support.superex.com/hc/zh-hk');
            }else if(this.language == 'ko'){
                window.open('https://support.superex.com/hc/ko')
            }else{
                window.open('https://support.superex.com/hc/en-001')
            }
        }
        else if(title === "300274"){
            //上币申请
            console.log('点击了上币申请');
            window.open('https://docs.google.com/forms/d/e/1FAIpQLSd0zIRGvBWB2Bv_fmiwqSMTx5vAcaPi7n443Jjj49UG8j-kOg/viewform')
        }else if(title === "DAO"){
            console.log('点击了DAO');
            window.open('https://support.superex.com/hc/en-001/articles/6736531883033-SuperEx-Global-DAO-Recruitment')
        }
    },
    /*openNewPage(url) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer'; // 安全性相关的设置，推荐添加
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 点击后移除该元素
    },*/
    openGroup(ev) {
      const target = ev.currentTarget;
      if (!(target instanceof HTMLElement)) {
        return;
      }
      target.parentElement.classList.toggle("state--open");
    }
    
  },
  mounted() {
    this.showSubGroup = this.$refs.showSubGroup;
  }
};
</script>
<style lang="scss" module>
@import "../../assets/uemo-scss/scss/abstracts/_mixins.scss";
@import "../../assets/uemo-scss/scss/abstracts/_breakpoint.scss";
@import "../../assets/uemo-scss/scss/abstracts/_functions.scss";
.m-site-map {
  padding: 120px 0 0;
}
.social-contact {
  gap: 72px;
  .logo-img {
    height: 48px;
  }
}
.social-group {
  gap: 16px;
}
.social-item {
  position: relative;
  z-index: var(--g--z-index);
  &:hover {
    .item-inner {
      color: color(var(--g--color-font--default));
      background-color: color(var(--g--color-theme--main));
    }
  }
  .item-inner {
    @include circle(64px);
    font-size: 36px;

    transition: 0.26s ease;

    color: color(var(--g--color-font--default), 0.5);
  }
}
.site-map {
  margin-top: 50px;
  .col-group {
    padding: 50px 0;

    border-bottom: 1px solid rgba(#dfe9fb, 0.15);
    &:last-child {
      border-bottom-width: 0;
    }
    &:global(.state--open) {
      .group-body {
        height: auto;
      }
    }
  }
  .group-title {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.6;
    .text {
      color: #fff;
    }
    .ic {
      font-size: 30px;

      color: color(var(--g--color-font--default), 0.7);
    }
  }
  .group-body {
    font-size: 26px;
    line-height: 1.6;

    overflow: hidden;

    height: 0;

    color: color(var(--g--color-font--default), 0.5);
  }
  .sub-group {
    padding-top: 50px;
  }
  .sub-item {
    padding: 9px 0;
    &:hover {
      color: color(var(--g--color-font--default), 0.7);
      .text::after {
        width: 100%;
      }
    }
    .text {
      position: relative;
      /* color: #fff; */
      transition: 0.36s ease;
      &::after {
        position: absolute;
        bottom: -0.3em;
        left: 0;

        width: 0%;
        height: 2px;

        content: "";
        transition: 0.36s ease;

        background-color: color(var(--g--color-font--default), 0.7);
      }
    }
  }
}
.group--sub {
  width: 100%;
  padding-bottom: 40px;

  border-radius: 42px 42px 0 0;
  background: #1f1f1f;
  // box-shadow: 0 -28px 38px 0 rgb(13, 10, 25 / 0.06);
  .group--sub-title {
    font-size: 36px;
    font-weight: 700;
    line-height: 140%;

    position: relative;

    padding: 60px 80px 30px;

    color: color(var(--g--color-font--default));
    .btn--close {
      position: absolute;
      top: 56px;
      right: 60px;

      width: 60px;
      height: 60px;
      .ic {
        font-size: 40px;

        color: color(var(--g--color-font--default));
      }
    }
  }
  .group--sub-inner {
    font-size: 26px;
    line-height: 1;

    overflow: auto;

    max-height: 50vh;
    padding: 0 80px;

    border-radius: 8px;

    overscroll-behavior: contain;
    .sub-item {
      @include ellipse(1);
      padding: 36px 0;

      transition: 0.26s ease;

      color: color(var(--g--color-font--default), 0.6);
      &:hover {
        color: color(var(--g--color-font--default));
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/SiteMap.vue